import styled from "@emotion/styled"
import { Container, Typography } from "@mui/material"
import * as api from "api"
import { GetWarrantyExtensionsTopTable, WarrantyBaseData } from "api/delek"
import SeoMetaData, { seoKeys } from "common/SeoMetaData"
import { StaticPropsFactoryProps } from "common/StaticPropsFactory"
import WarrantyExtensionsForm from "components/WarrantyExtensions/WarrantyExtensionsForm"
import WarrantyExtensionsTable from "components/WarrantyExtensions/WarrantyExtensionsTable"
import WarrantyExtensionsMarkdown from "docs/warranty-extenstions.mdx"
import { GetStaticProps } from "next"

const Styled = {
  Wrapper: styled.div`
    text-align: left; // flipped by mui
  `,
  Title: styled(Typography)`
    margin-top: 40px;
  `,
  Description: styled(Typography)`
    font-size: 14px;
    margin-top: 10px;
    line-height: 1.43;
    color: ${(p) => p.theme.colors.marine};
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 18px;
      margin-top: 5px;
      margin-bottom: 25px;
    }
  `,
  Subtitle: styled(Typography)`
    font-size: 18px;
    margin-top: 10px;
    margin-bottom: 20px;
    color: ${(p) => p.theme.colors.marine};
    ${(p) => p.theme.breakpoints.up("md")} {
      font-weight: bold;
    }
  `,
}

type WarrantyExtensionsProps = StaticPropsFactoryProps & {
  extensions: WarrantyBaseData[]
}

export const getStaticProps: GetStaticProps<
  WarrantyExtensionsProps,
  any
> = async () => {
  const seo = await api
    .getSeoKey(seoKeys.warrantyExtensions)
    .then(api.extractData)
  const {
    data: { data: extensions },
  } = await GetWarrantyExtensionsTopTable()
  return { props: { seo, extensions }, revalidate: 60 }
}

const WarrantyExtensions = ({ seo, extensions }: WarrantyExtensionsProps) => {
  return (
    <Styled.Wrapper>
      <SeoMetaData data={seo} />
      <Container>
        <Styled.Title variant="h1">בדיקת תחולת הארכת אחריות</Styled.Title>
        <Styled.Description>
          יצרן הרכב מודיע מעת לעת על הארכת אחריות לרכיבים מסוימים הרלוונטית
          לקבוצת רכבים מסויימת. בטבלה מטה מפורטות הארכות האחריות הפעילות.
        </Styled.Description>
        <Styled.Subtitle>
          לבדיקה האם רכבך נהנה מהארכת אחריות נא הזינו את מספר הרישוי או מספר
          השלדה
        </Styled.Subtitle>
      </Container>
      <WarrantyExtensionsForm />
      <WarrantyExtensionsTable data={extensions} />
      <WarrantyExtensionsMarkdown />
    </Styled.Wrapper>
  )
}

export default WarrantyExtensions
